import { render, staticRenderFns } from "./orderLogin.vue?vue&type=template&id=410b3566&scoped=true&"
import script from "./orderLogin.vue?vue&type=script&lang=js&"
export * from "./orderLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b3566",
  null
  
)

export default component.exports